module.exports = __webpack_public_path__ + "static/media/schedule.2482ec2e.png";